import React from 'react';
import PropTypes from 'prop-types';

import LightMontlyHistogramContainer from '../LightMontlyHistogramContainer';

const MonthlyHistogramContainer = (props) => {
  const { carousel } = props;
  const newProps = Object.assign({}, props, {
    skeletonType: 'SkeletonMonthlyHistogram',
  });
  newProps.carousel = Object.assign({}, carousel, { renderMonthlyBar: 'MonthlyHistogramBarV2' });
  return <LightMontlyHistogramContainer {...newProps} />;
};

MonthlyHistogramContainer.componentName = 'MonthlyHistogramContainer';

MonthlyHistogramContainer.propTypes = {
  /**
   * Define if carousel navigation
   */
  carousel: PropTypes.objectOf(PropTypes.any),
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any),
};

MonthlyHistogramContainer.defaultProps = {
  carousel: {},
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'faresGridBackgroundImage', // TODO: Which eventType is this component's
  },
};

export default MonthlyHistogramContainer;
